import React from 'react';
import { Col, Row } from 'components';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';
import { Pricing } from 'feature/brandTabs/pricingAndSuppliers/pricing';
import { MainSupplier } from 'feature/brandTabs/pricingAndSuppliers/mainSupplier';
import { SupplierGrid } from 'feature/brandTabs/pricingAndSuppliers/supplierGrid';

export const PricingAndSuppliers = React.memo(() => {
  return (
    <Row gutter={[0, 32]}>
      <Col span={24}>
        <Row gutter={[32, 0]}>
          <Col flex={'1'}>
            <HasAccess role={PERMISSIONS.brands.pricing_rules.read}>
              <Pricing />
            </HasAccess>
          </Col>
          <Col flex={'1'}>
            <HasAccess role={PERMISSIONS.brands.main_supplier.read}>
              <MainSupplier />
            </HasAccess>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <HasAccess role={PERMISSIONS.brands.supplier.read}>
          <SupplierGrid />
        </HasAccess>
      </Col>
    </Row>
  );
});
